export const FSRemoveLightBoxActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
    EXPAND: 'EXPAND',
    FS_REMOVE_INVALID_ACTION: 'FS_REMOVE_INVALID_ACTION',
};
